<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import router from '@/router';

import { required, maxLength } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'User Profile',
		meta: [
			{
				name: 'User Profile',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			userId: null,
			userTypeId: null,
			userName: null,
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			autoClose: '',
			attendWorship: '',
			isKnowApplicant: '',
			cooperation: '',
			options: ['Yes', 'No'],
			preservePage: 1,
			pageLimit: 10,
			status: ['Active', 'InActive'],
			userData: JSON.parse(localStorage.getItem('web_user')),
			tags: null,
			hours: null,
			totalHours: '',
			hourForm: {
				user_id: this.user_id,
				comment: '',
				date: '',
				hours: '',
				minutes: '',
			},
			tagForm: {
				name: '',
			},
			searchForm: {
				tag: '',
				commenter: '',
			},
			isTag: false,
			isCommenter: false,
			isSearching: false,
			isLoading: false,
			noRecord: false,
			searchBy: '',
			isUpdate: false,
			isAdd: false,
			typeSubmit: false,
			modalTitle: '',
			commentId: '',
			contactInfoForm: {
				username: '',
				status: '',
				avatar: '',
				t_shirt: '',
				email: '',
				address: '',
				phone: '',
				city: '',
				state: '',
				zip_code: '',
				age: '',
				gender: '',
				DOB: '',
				address2: '',
				mobile: '',
			},
		};
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	validations: {
		hourForm: {
			comment: { comment: maxLength(200) },
			date: { required },
			hours: { required },
			minutes: '',
		},
	},
	mounted() {
		this.userId = this.userData.id;
		this.getHours();
		this.getContactDetail();
	},
	methods: {
		getContactDetail() {
			var token = this.userData.token;
			//   var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/' + this.userId, config)
					.then((res) => {
						if (res.status == 200) {
							this.contactInfoForm = res.data.response;
							this.userName = this.contactInfoForm.username;
							// this.contactInfoForm.age = this.calculateAge(res.data.response.DOB);
							// this.contactInfoForm.DOB = moment(res.data.response.DOB,'DD/MM/YYYY').format('YYYY-MM-DD');
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},

		getHours(page) {
			var config = {
				headers: { Authorization: 'Bearer ' + this.userData.token },
			};

			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			// let filter = '&per_page=' + this.pageLimit
			let userId = 'user_id=' + this.userId;
			//   if (this.searchForm.tag){
			//     filter += '&tag='+ this.searchForm.tag
			//   }
			//   if (this.searchForm.commenter){
			//     filter += '&commenter='+ this.searchForm.commenter
			//   }
			axios.get('user/hours?' + userId, config).then((res) => {
				this.hours = res.data.response;
				this.calculateTotalHours();
				this.isLoading = false;
				if (!this.hours.length) {
					this.noRecord = true;
					if (page > 1) {
						this.getHours(page - 1);
					}
				}
			});
		},

		calculateTotalHours() {
			this.totalHours = '';
			let totalMinutes = 0;
			if (this.hours.length > 0) {
				for (var i = 0; i < this.hours.length; i++) {
					totalMinutes += parseInt(this.hours[i].hours) * 60 + parseFloat(this.hours[i].minutes);
				}
			}

			this.totalHours = Math.floor(totalMinutes / 60) + ' hours ' + (totalMinutes % 60) + ' minutes';
		},

		showEditModal(hours) {
			this.modalTitle = 'Edit Hours';
			this.$bvModal.show('hourModal');
			this.hourForm.comment = hours.comment;
			this.hourForm.date = hours.date;
			this.hourForm.hours = hours.hours;
			this.hourForm.minutes = hours.minutes;
			this.hourForm.user_id = this.userId;
			this.hourId = hours.id;
			this.isUpdate = true;
			this.isAdd = false;
		},

		showAddModal() {
			this.typeSubmit = false;
			this.modalTitle = 'Log Hours';
			this.$bvModal.show('hourModal');
			this.isAdd = true;
			this.isUpdate = false;
			this.commentForm = {
				date: '',
				hours: '',
				minutes: '',
				comment: '',
			};
		},

		updateHours() {
			this.typesubmit = true;
			this.$v.$touch();
			if (!this.$v.hourForm.$invalid) {
				// var token = localStorage.getItem('token');
				var token = this.userData.token;
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					axios
						.patch('user/hours/' + this.hourId, this.hourForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Hours updated successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.getHours();
								this.typeSubmit = false;
								this.$bvModal.hide('hourModal');
								this.hourForm = {
									date: '',
									hours: '',
									minutes: '',
									comment: '',
								};
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'danger',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		deleteHours(hourId) {
			// var token = localStorage.getItem('token');
			var token = this.userData.token;
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				Swal.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes, delete it!',
				}).then((result) => {
					if (result.value) {
						axios
							.delete('user/hours/' + hourId, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Deleted!',
										text: 'Hours have been deleted!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getHours();
								}
							})
							.catch((err) => {
								if (err.response) {
									Swal.fire({
										title: 'Error!',
										text: err.response.data.error.message,
										icon: 'danger',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				});
			}
		},

		addHours() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (!this.$v.hourForm.$invalid) {
				// var token = localStorage.getItem('token');
				var token = this.userData.token;

				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					this.hourForm.user_id = this.userId;
					if (this.hourForm.minutes == '') {
						this.hourForm.minutes = 0;
					}
					axios
						.post('user/hours', this.hourForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Hours added successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.$bvModal.hide('hourModal');
								this.hourForm = {
									date: '',
									hours: '',
									minutes: '',
									comment: '',
								};
								this.typeSubmit = false;
								this.getHours();
							}
						})
						.catch((err) => {
							if (err.response.data.error.custom_code == '401') {
								console.log(err.response.data.error);
							}
							if (err.response) {
								console.log(err.response.data.error);
							}
						});
				}
			}
		},

		searchOption(event) {
			this.searchForm = {
				tag: '',
				commenter: '',
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearch();
			}
			if (selectedValue == 'tag') {
				this.isTag = true;
				this.isCommenter = false;
				this.isSearching = true;
			}
			if (selectedValue == 'commenter') {
				this.isTag = false;
				this.isCommenter = true;
				this.isSearching = true;
			}
		},

		searchComments() {
			this.getComments();
		},

		resetSearch() {
			this.searchForm = {
				tag: '',
				commenter: '',
			};
			this.isSearching = false;
			this.isTag = false;
			this.isCommenter = false;
			this.searchBy = '';
			this.getComments();
		},
		gotoRoles() {
			router.push({ name: 'volunteer-roles' });
		},
		gotoMentorHours() {
			router.push({ name: 'mentor-hours' });
		},
		loginPage() {
			router.push({ name: 'login' });
		},
		gotoProfile() {
			router.push({ name: 'profile' });
		},
		gotoApplication() {
			router.push({ name: 'review-application' });
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Mentor Hours</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a href="javascript:">Contact Us</a></p>
						<!--              <logout-button></logout-button>-->
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form d-flex container pb-5 pt-5">
			<b-button class="btn-custom ms-0" variant="custom" @click="gotoProfile"> Profile Information </b-button>
			<b-button v-if="userData['user_type_id'] === 4" class="btn-custom" variant="custom" @click="gotoRoles"> Roles </b-button>
			<b-button v-if="userData['user_type_id'] === 3 || (userData['user_type_id'] === 4 && userData['is_upgraded'] === 1)" class="btn-custom" variant="custom" @click="gotoMentorHours"> Mentor Hours </b-button>
			<b-button class="btn-custom" variant="custom" v-if="contactInfoForm.status !== 1" @click="gotoApplication"> Review Application </b-button>
		</div>

		<!-- main content -->
		<div class="card custom-form container pb-5 pt-5" v-if="userId">
			<div class="card-body">
				<!-- add mentor hour  -->
				<div class="d-flex">
					<div class="mb-4 mdl-btns ms-auto">
						<!--Add New Comment Modal-->
						<b-button @click="showAddModal" variant="primary">Add Hours</b-button>
						<b-modal id="hourModal" centered :title="modalTitle" title-class="font-18" hide-footer>
							<form>
								<div class="mb-3">
									<label>Select Date</label>
									<div>
										<input
											type="date"
											v-model="hourForm.date"
											class="form-control"
											:class="{
												'is-invalid': typeSubmit && $v.hourForm.comment.$error,
											}"
										/>
										<div v-if="typeSubmit && $v.hourForm.date.$error" class="invalid-feedback">
											<span v-if="!$v.hourForm.date.required">Date is required.</span>
										</div>
									</div>
								</div>

								<div class="mb-3">
									<div class="row">
										<div class="col-6">
											<label>Hours</label>
											<div>
												<input
													type="number"
													v-model="hourForm.hours"
													class="form-control"
													:class="{
														'is-invalid': typeSubmit && $v.hourForm.hours.$error,
													}"
												/>
												<div v-if="typeSubmit && $v.hourForm.hours.$error" class="invalid-feedback">
													<span v-if="!$v.hourForm.hours.required">Hours are required.</span>
												</div>
											</div>
										</div>
										<div class="col-6">
											<label>Minutes</label>
											<div>
												<!-- <input type="number" v-model="hourForm.minutes" class="form-control" :class="{
                                        'is-invalid': typeSubmit && $v.hourForm.minutes.$error,
                                    }"> -->
												<select
													class="form-select custom-select"
													v-model="hourForm.minutes"
													:class="{
														'is-invalid': typeSubmit && $v.hourForm.minutes.$error,
													}"
												>
													<option value="0">0 mins</option>
													<option value="15">15 mins</option>
													<option value="30">30 mins</option>
													<option value="45">45 mins</option>
												</select>
												<div v-if="typeSubmit && $v.hourForm.minutes.$error" class="invalid-feedback">
													<!-- <span v-if="!$v.hourForm.minutes.required"
                                    >Hours are required.</span
                                    > -->
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="mb-3">
									<label>How did you spend your time? (optional)</label>
									<div>
										<textarea
											v-model="hourForm.comment"
											class="form-control"
											name="comment"
											rows="3"
											placeholder="For your tracking purposes only"
											:class="{
												'is-invalid': typeSubmit && $v.hourForm.comment.$error,
											}"
										></textarea>
										<div v-if="typeSubmit && $v.hourForm.comment.$error" class="invalid-feedback">
											<span v-if="!$v.hourForm.comment.maxLength">This value is too long. It should have 200 words or less</span>
										</div>
									</div>
								</div>

								<div class="mb-5">
									<div>
										<button type="button" v-if="isAdd" @click="addHours" class="btn btn-primary">Add Hours</button>
										<button type="button" v-if="isUpdate" @click="updateHours" class="btn btn-primary">Update Hours</button>
									</div>
								</div>
							</form>
						</b-modal>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-md-12 px-0 cards-cont">
						<div v-if="this.hours">
							<div class="table-responsive">
								<table class="table table-bordered table-hover table-striped align-middle mb-0">
									<tbody>
										<tr v-if="noRecord">
											<td colspan="4" class="p-0">
												<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
											</td>
										</tr>

										<tr v-if="isLoading">
											<td colspan="4" class="text-center p-0">
												<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
											</td>
										</tr>

										<tr v-else v-for="(hour, index) in this.hours" :key="index">
											<td>
												{{ hour.date | moment }}
											</td>
											<td>{{ hour.hours }} hours {{ hour.minutes }} minutes</td>
											<td>
												<p class="text-muted mb-0 text-wrap">
													{{ hour.comment }}
												</p>
											</td>
											<td style="position: relative">
												<p class="text-muted mb-0 icons-wrap">
													<a href="javascript:;" @click="showEditModal(hour)" class="text-dark"><i class="bx bxs-pencil"></i></a>
													<a href="javascript:;" @click="deleteHours(hour.id)" class="ms-1 text-dark"><i class="bx bx-x font-size-24"></i></a>
												</p>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr>
											<th>Total Hours</th>
											<th>{{ this.totalHours }}</th>
											<th colspan="2"></th>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form" v-else>
			<div class="text-center mt-3">
				<b-button class="btn-custom" variant="custom" @click="loginPage"> Login </b-button>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>

<style scoped>
.btn.btn-primary {
	background: #d0885a !important;
	border: 1px solid #d0885a !important;
}
.mdl-btns button:nth-child(1) {
	margin-right: 1rem;
}
.icons-wrap {
	position: absolute;
	top: 7px;
	right: 10px;
	display: flex;
}
.icons-wrap a:first-child {
	margin-top: 4px;
}
.cards-cont .card:nth-child(odd) .card-header {
	background-color: #32b1f9;
}
.app-search input,
.app-search select {
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}
.app-search .btn-find {
	width: 40%;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	box-shadow: none;
}
.app-search .btn-reset {
	width: 40%;
	font-size: 15px;
	box-shadow: none;
	border-radius: 30px;
}
.modal-body {
	padding-bottom: 30px !important;
}
</style>
